import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { Countdown } from './Countdown';
import { Kicker } from './Section';
export function Urgency() {
  const {
    expired
  } = useCountdown();
  if (expired) return null;
  return <section aria-label="Launch price countdown" className="w-full bg-forest text-white" data-id="element-271" data-mp="1wz5bnimtbr6z">
      <div className="mx-auto max-w-content px-5 py-16 text-center sm:px-8 sm:py-20" data-id="element-272" data-mp="21wx1m73wd38j">
        <Kicker data-id="element-273" data-mp="1o6bh6dysol8j">Launch price — ends in</Kicker>
        <div className="mt-7" data-id="element-274" data-mp="1o58uki8i94yf">
          <Countdown data-id="element-275" data-mp="1sy1wkycl9z6t" />
        </div>
        <p className="mt-7 font-sans text-[15px] text-white/60" data-id="element-276" data-mp="1szd2p4tibj13">
          Then it returns to the regular price of $97.
        </p>
      </div>
    </section>;
}